module.exports = __webpack_public_path__ + "media/cards/24-e3d340fa.png";